




import { defineClassComponent } from '@/hooks'
import { jointGoodsModelProvider } from '../model'

export default defineClassComponent(
  () =>
    class {
      jointGoodsModel = jointGoodsModelProvider.inject()
    },
)
